import { useEffect } from "react";
import { useSettings } from "../lib/settings";

// Google için işletme bilgisi (schema.org AutoRental).
// Site Ayarları'ndaki gerçek bilgilerden üretilir; örnek/yer tutucu değerler Google'a gönderilmez.
const PLACEHOLDER = /0{3}\s?0{2}\s?0{2}|5{3}5{4}|5555555555|Büyükdere Caddesi No:255/i;
const real = (v) => (v && !PLACEHOLDER.test(v) ? v : undefined);

function parseHours(text) {
  // "Pazartesi - Cumartesi: 09:00 - 19:00" → schema.org openingHours "Mo-Sa 09:00-19:00"
  const days = { pazartesi: "Mo", salı: "Tu", sali: "Tu", çarşamba: "We", carsamba: "We", perşembe: "Th", persembe: "Th", cuma: "Fr", cumartesi: "Sa", pazar: "Su" };
  const m = (text || "").toLowerCase().match(/([a-zçğıöşü]+)\s*-\s*([a-zçğıöşü]+)\s*:?\s*(\d{1,2}[:.]\d{2})\s*-\s*(\d{1,2}[:.]\d{2})/i);
  if (!m || !days[m[1]] || !days[m[2]]) return undefined;
  return `${days[m[1]]}-${days[m[2]]} ${m[3].replace(".", ":")}-${m[4].replace(".", ":")}`;
}

export function BusinessSchema() {
  const s = useSettings();
  useEffect(() => {
    const phone = real(s.phone);
    const waNumber = real(s.whatsapp)?.match(/wa\.me\/(\d+)/)?.[1];
    const data = {
      "@context": "https://schema.org",
      "@type": "AutoRental",
      "@id": "https://viaprimeluxury.com/#business",
      name: "VIA PRIME Luxury",
      url: "https://viaprimeluxury.com/",
      logo: "https://viaprimeluxury.com/assets/logo-full.png",
      image: "https://viaprimeluxury.com/assets/logo-full.png",
      description: "İstanbul merkezli kurumsal uzun dönem lüks araç kiralama. 2026 model sıfır km premium sedan filosu.",
      areaServed: { "@type": "City", name: "İstanbul" },
      priceRange: "₺₺₺",
      email: real(s.email),
      telephone: phone || (waNumber ? `+${waNumber}` : undefined),
      openingHours: parseHours(s.hours),
      address: real(s.address)
        ? { "@type": "PostalAddress", streetAddress: s.address, addressLocality: "İstanbul", addressCountry: "TR" }
        : undefined,
      sameAs: [s.instagram].filter(Boolean),
    };
    let el = document.getElementById("business-schema");
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = "business-schema";
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
  }, [s]);
  return null;
}
